import React, { useEffect, useState } from "react";
import Form from "../../components/Form/Form";
import { useFormConfig } from "./TopicFieldsConfig";
import { addTopic, updateTopic } from "../../services/TopicService";

function TopicForm({ topic, onClose }) {
  const initialModuleId = topic?.module_id || topic?.Module?.id || "";
  const { topicForm } = useFormConfig(initialModuleId, !!topic);
  const [formData, setFormData] = useState(topicForm.initialFormData);

  useEffect(() => {
    if (topic) {
      const updatedFormData = {
        title: topic.title || "",
        moduleId: topic.module_id || topic.Module?.id || "",
        remarks: topic.remarks || "",
      };
      setFormData(updatedFormData);
    }
  }, [topic]);

  const handleSubmit = async (formData) => {
    try {
      if (topic) {
        await updateTopic(topic.id, formData);
      } else {
        await addTopic(formData);
      }
      onClose();
    } catch (error) {
      console.error("Error submitting topic:", error);
    }
  };

  return (
    <Form
      formTitle={topic ? "Update Topic" : topicForm.formTitle}
      initialFormData={formData}
      fieldConfig={topicForm.fieldConfig}
      onSubmit={handleSubmit}
      onClose={onClose}
    />
  );
}

export default TopicForm;